import _ from "lodash";
import { once } from "../events/jQuerySubscription";
export const errorClass = "form-error";
export const displayErrors = (form, result) => {
    form.find(`.${errorClass}`).removeClass(errorClass);
    if (result.ValidationErrors) {
        highlightFields(form, result.ValidationErrors);
        highlightTabs(form, result.ValidationErrors);
        highlightPanels(form, result.ValidationErrors);
    }
    displayErrorSummary(form, result);
};
const highlightFields = (form, errors) => {
    for (const key in errors) {
        const inputs = form
            .find(`label[for="${key}"],[name="${key}"]`)
            .addClass(errorClass)
            .not("label");
        once(inputs, "blur", (e) => {
            const input = $(e.currentTarget);
            const label = $(`label[for="${input.prop("name")}"]`);
            input.removeClass(errorClass);
            label.removeClass(errorClass);
        });
    }
};
const highlightTabs = (form, errors) => {
    for (const key in errors) {
        form.find(`[name="${key}"]`)
            .closest(".tab-pane")
            .toArray()
            .forEach((p) => {
            const id = $(p).attr("id");
            id && $(`[data-tab-target="#${id}"]`).addClass(errorClass);
        });
    }
};
const highlightPanels = (form, errors) => {
    for (const key in errors) {
        form.find(`[name="${key}"]`)
            .closest(".panel")
            .find(".panel-heading")
            .addClass(errorClass);
    }
};
const displayErrorSummary = (form, result) => {
    if (!result.Message && !result.ValidationErrors)
        return;
    const notification = form.find("[data-validation-notification]");
    notification.removeClass("hidden");
    const container = document.createElement("div");
    if (result.Message)
        container.textContent = result.Message;
    if (result.ValidationErrors) {
        const list = document.createElement("ul");
        list.className = "list-inside list-disc";
        container.appendChild(list);
        _.uniq(Object.values(result.ValidationErrors)).forEach((e) => {
            const item = document.createElement("li");
            item.textContent = e;
            list.appendChild(item);
        });
    }
    notification.find("[data-validation-summary]").html(container.innerHTML);
};
